// import hooks
import { useTranslation } from 'react-i18next';

// import styles
import { StyledUnsavedDataContainerAlert } from './UnsavedDataAlert.styles';

const UnsavedDataAlert = ({ textContent }: { textContent?: string }) => {
  const { t } = useTranslation('common');

  return (
    <StyledUnsavedDataContainerAlert severity="warning" variant="standard">
      {textContent ?? t('unsavedData')}
    </StyledUnsavedDataContainerAlert>
  );
};

export default UnsavedDataAlert;
